export class Snackbar {
    constructor(
        public status_class: string = 'info',
        public text: string = 'Snackbar!',
        public autoClose: boolean = true,
        public time: number = 3000,
        public action_buttons: any[] = null,
        public active: boolean = false
    ) {}

    activate() {
        this.active = true;
    }

    deactivate() {
        this.active = false;
    }

    error(): void {
        this.status_class = 'error';
    }

    warning(): void {
        this.status_class = 'warning';
    }

    success(): void {
        this.status_class = 'success';
    }

    info(): void {
        this.status_class = 'error';
    }
}
